<template>
  <div class="flex flex-wrap items-center gap-1 break-words text-sm font-semibold leading-5 text-gray-600">
    <template
      v-for="(item, index) in visibleBreadcrumbItems"
      :key="item.id"
    >
      <span
        v-if="index > 0"
        aria-hidden="true"
        class="shrink-0"
      >·</span>
      <NuxtLink
        :to="$localePath(`/${city.slug}/catalog/${item.catalogSlug}`)"
        class="shrink-0 overflow-hidden text-ellipsis"
        :aria-label="`Перейти в категорию ${item.name}`"
      >
        {{ item.name }}
      </NuxtLink>
    </template>
  </div>
</template>

<script setup>
const props = defineProps({
  category: {
    type: Object,
    default: () => ({}),
  },
})

const { city } = useSearchForm()
const { isNarrow } = useLotPageLayout()

const catalogSlug = (c) => (c?.canonicalCategory && c.canonicalCategory.slug) || c?.slug || ''

/** Цепочка только из lot.category: ancestors + текущая; без categories store (на клиенте стор часто пустой). */
const breadcrumbItems = computed(() => {
  const cat = props.category
  if (!cat?.id) {
    return []
  }

  const current = {
    id: cat.id,
    name: cat.name,
    slug: cat.slug,
    canonicalCategory: cat.canonicalCategory,
  }

  if (Array.isArray(cat.ancestors) && cat.ancestors.length > 0) {
    const items = [...cat.ancestors, current]
    items.sort((a, b) => Number(a.id) - Number(b.id))
    return items.map((c) => ({
      id: String(c.id),
      name: c.name || '',
      catalogSlug: catalogSlug(c),
    }))
  }

  return [
    {
      id: String(current.id),
      name: current.name || '',
      catalogSlug: catalogSlug(current),
    },
  ]
})

const visibleBreadcrumbItems = computed(() => {
  const items = breadcrumbItems.value
  if (items.length <= 2 || !isNarrow.value) {
    return items
  }
  return items.slice(-2)
})
</script>
